import { render, staticRenderFns } from "./ScreenGroupsContainer.vue?vue&type=template&id=4b7e7fd1&"
import script from "./ScreenGroupsContainer.vue?vue&type=script&lang=js&"
export * from "./ScreenGroupsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports